module.exports = __webpack_public_path__ + "img/horizontal_2_1_8023.1e744149.png";